/** Sprint 5-c · 公司會議室 · 建立會議。
 * 日曆整合 Stage 3（H.4）：建立會議改走「我的日曆」的會議表單（勾「這是會議」推導產生會議），
 * 本舊頁停用——保留路由但直接導回新流程，避免兩套建立邏輯。
 */
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const OfficeMeetingCreatePage: React.FC = () => {
  useEffect(() => { /* 舊建立頁已停用·見 Stage 3 H.4 */ }, []);
  return <Navigate to="/ee_my_calendar?new=meeting" replace />;
};

export default OfficeMeetingCreatePage;
